import React, { useMemo } from 'react';
import { Card, Stack, Typography, Sheet, Button } from '@mui/joy';
import RichTextEditor from '../../../components/RichTextEditor';
import { DESCRIPTION_TEMPLATES } from '../data/descriptionTemplates';
import { applyDescriptionTemplateText, renderDescriptionHtml } from '../utils/richTextDescription';

interface Props {
  orgName?: string;
  orgCode?: string;
  reference?: string;
  customerName?: string;
  siteAddress?: string;
  title?: string;
  lines?: any[];
  value: string;
  onChange: (next: string) => void;
}

export const DescriptionAssistant: React.FC<Props> = ({
  orgName,
  orgCode,
  reference,
  customerName,
  siteAddress,
  title,
  lines,
  value,
  onChange,
}) => {
  const templates = useMemo(() => {
    const ctx = { orgCode, orgName, reference, customerName, siteAddress, title, lines };

    // Build a renderable list (dynamic templates use build(ctx))
    const rendered = DESCRIPTION_TEMPLATES
      .filter(t => (!t.org || t.org === orgCode))
      .map(t => {
        const text = (t.build ? t.build(ctx) : (t.body || '')).trim();
        return { title: t.title, text };
      })
      .filter(t => !!t.text)
      // Variables feature disabled: remove any templates that contain {{...}} tokens.
      .filter(t => !/\{\{[^}]+\}\}/.test(t.text));

    return rendered;
  }, [orgCode, orgName, reference, customerName, siteAddress, title, lines]);

  const insert = (text: string, mode: 'use'|'append') => {
    onChange(applyDescriptionTemplateText(value, text, mode));
  };

  // Variables feature disabled

  return (
    <Card sx={{ p: 2 }}>
      <Stack spacing={1}>
        <Typography level="title-md">Description</Typography>
        <RichTextEditor value={renderDescriptionHtml(value)} onChange={onChange} height={320} />

        {/* AI Suggestion UI hidden */}

        <Sheet variant="soft" sx={{ p: 1, borderRadius: 6 }}>
          <Typography level="title-sm" sx={{ mb: 1 }}>Templates</Typography>
          <Stack spacing={1}>
            {templates.map((t, i) => (
              <Stack key={i} direction="row" spacing={1} alignItems="center">
                <Typography level="body-sm" sx={{ flex: 1 }}>{t.text}</Typography>
                <Button size="sm" onClick={() => insert(t.text, 'use')}>Use</Button>
                <Button size="sm" variant="outlined" onClick={() => insert(t.text, 'append')}>Append</Button>
              </Stack>
            ))}
          </Stack>
        </Sheet>
      </Stack>
    </Card>
  );
};

export default DescriptionAssistant;



